const roles = [
  { role: 1, description: "questioner" },
  { role: 2, description: "admin" },
  { role: 3, description: "school_manager" },
  
  { role: 4, description: "student" },
];

const roleArr = {
  notAuth: [3],
  admin: [2],
  schoolManager: [3],
  statusbar: [4],
  adminAndSchoolManager: [2, 3],
  isAuth: [1, 2, 3, 4],
};

/* role pages */
const rolePageArr = {
  // Public/Common pages accessible by all roles
  HomePage: [1, 2, 3, 4],
  ErrorPage: [1, 2, 3, 4],
  Error404: [1, 2, 3, 4],
  TosPage: [1, 2, 3, 4],
  PrivacyPage: [1, 2, 3, 4],
  CookiePolicyPage: [1, 2, 3, 4],
  ContactPage: [1, 2, 3, 4],
  
  
  // User related pages
  UsersHome: [2, 3, 4],
  UsersSignIn: [1, 2, 3, 4],
  UsersUpdate: [2, 3, 4],
  UsersDetail: [2, 3, 4],
  UsersList: [2],  // Only Admin can see all users
  UsersSearch: [2], // Only Admin can search all users
  UsersLogin: [1, 2, 3, 4],
  UsersForgotPassword: [1, 2, 3, 4],
  
  // Schema pages - only for admin
  SchemaHome: [],
  SchemaCreate: [],
  SchemaUpdate: [],
  SchemaDetail: [],
  SchemaList: [],
  SchemaSearch: [],
  
  // Contact pages - admin access only
  ContactsHome: [2],
  ContactsCreate: [2], 
  ContactsUpdate: [2], 
  ContactsDetail: [2], 
  ContactsList: [2], 
  ContactsSearch: [2], 
  
  // Tasks pages - admin and school manager access
  TasksHome: [2],
  TasksCreate: [2],
  TasksUpdate: [2],
  TasksDetail: [2],
  TasksList: [2],
  TasksSearch: [2],
  
  // Kanban and Calendar - admin and school manager access
  KanbanBoard: [2],
  CalendarView: [2],
  
  // Admin pages - admin only
  AdminHome: [2],
  AdminSettings: [2],
  AdminSiteSettings: [2],
  AdminUsers: [2],
  AdminAnalytics: [2],
  AdminLogs: [2],
  AdminSchema: [2],
  AdminSchemaCreate: [2],
  AdminSchemaUpdate: [2],
  AdminSchemaDetail: [2],
  AdminContacts: [2],
  DockerInfo: [2],
  AdminMigration: [2],  // Only admin and super-admin can access migration
  

  // Books management
  BooksHome: [],  // All can access the books home
  BooksCreate: [2, 3],   // Admin and school manager can create books
  BooksUpdate: [2],   // Admin and school manager can update books
  BooksDetail: [2], // All can view book details
  BooksList: [2],   // All can list books
  BooksSearch: [], // All can search books
  

  // Libraries management
  LibrariesHome: [],
  LibrariesCreate: [], 
  LibrariesUpdate: [], 
  LibrariesDetail: [], 
  LibrariesList: [2, 3], 
  LibrariesSearch: [], 
  
  // Schools management - admin only
  SchoolsHome: [],
  SchoolsCreate: [], 
  SchoolsUpdate: [], 
  SchoolsDetail: [2,3], 
  SchoolsList: [2,3], 
  SchoolsSearch: [], 
  
  // Students management
  StudentsHome: [],
  StudentsCreate: [2,3], 
  StudentsUpdate: [2,3], 
  StudentsDetail: [2,3], 
  StudentsDetailShort: [1,2,3,4],
  StudentsList: [2,3], 
  StudentsSearch: [], 
  
  // Library books management
  Library_booksHome: [2,3],
 
  Library_booksCreate: [2,3], 
  Library_booksUpdate: [2,3], 
  Library_booksDetail: [2,3], 
  Library_booksDetailShort: [2,3],
  Library_booksList: [2,3], 
  Library_booksSearch: [], 
  
  // Book loans management
  Book_loansHome: [2,3],
  Book_loansCreate: [2,3], 
  Book_loansUpdate: [2,3], 
  Book_loansDetail: [2,3,4], // Students can see their own loans
  Book_loansList: [2,3],   // Students can see their own loans
  Book_loansSearch: [], // Students can search their own loans
  
  // Library settings management
  Library_settingsHome: [],
  Library_settingsCreate: [], 
  Library_settingsUpdate: [], 
  Library_settingsDetail: [], 
  Library_settingsList: [], 
  Library_settingsSearch: [], 
  
  // Reports and Statistics module - admin and school manager access
  ReportsHome: [],          // Admin and school manager access
  ReportsOverdue: [],       // Admin and school manager access
  ReportsPopularBooks: [],  // Admin and school manager access
  ReportsLibraryUsage: [],  // Admin and school manager access
  ReportsStudentStats: [],  // Admin and school manager access
  ReportsTrends: [],        // Admin and school manager access
  ReportsInventory: [],     // Admin and school manager access
  
  empty: [],
};

export default { ...roleArr, ...rolePageArr };
export { roles };
